import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-inputgroup" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-signature p-mr-3" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FloatLabel, {
      label: _ctx.label || 'Search material'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AutoComplete, _mergeProps({
          dropdown: !_ctx.noDropdown,
          forceSelection: _ctx.forceSelection
        }, _ctx.$attrs, {
          completeOnFocus: "",
          modelValue: _ctx.searchBox,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchBox = $event)),
          suggestions: _ctx.suggestions,
          field: _ctx.selectedLabel,
          minLength: 2,
          onItemSelect: _ctx.onSelect,
          onClear: _ctx.onClear,
          onComplete: _ctx.search
        }), {
          item: _withCtx(({item}) => [
            _hoisted_2,
            _createElementVNode("span", null, _toDisplayString(item.name), 1)
          ]),
          _: 1
        }, 16, ["dropdown", "forceSelection", "modelValue", "suggestions", "field", "onItemSelect", "onClear", "onComplete"])
      ]),
      _: 1
    }, 8, ["label"]),
    (_ctx.noDropdown)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          disabled: _ctx.$attrs.disabled,
          icon: "pi pi-times",
          onClick: _ctx.onClear
        }, null, 8, ["disabled", "onClick"]))
      : _createCommentVNode("", true)
  ]))
}